<template>
    <div id="modal-edit-dataset">

        <div class="rp-overlay"></div>

        <div class="rp-modal">
            
            <div v-if="!layout.loading">

                <div class="rp-modal-header">
                    <h3 class="rp-modal-title">{{ $t('Dataset profile') }}</h3>
                    <button class="rp-btn-dismiss"
                        @click="$emit('closeModal')">
                        <XIcon class="w-5 h-5" />
                    </button>
                </div>

                <div class="bg-white p-5">
                    <div class="relative text-gray-700 dark:text-gray-300 px-5 pt-3">
						<div class="text-normal mb-2 font-bold">{{ $t('Name') }}</div>
						<input type="text" class="form-control py-3 px-4 border-transparent bg-gray-200 pr-10" v-model="layout.newName"  />
						<div class="text-xs pt-2 text-gray-600 text-left">{{ $t('Use up to 32 characters, which can include letters, numbers, and underscores') }}.</div>
					</div>
					<div class="relative text-gray-700 dark:text-gray-300 px-5 pt-5 pb-5">
						<div class="text-normal mb-2 font-bold">{{ $t('A brief description of the goal') }}</div>
						<textarea v-model="layout.newDescription" class="form-control h-32 rounded border bg-gray-200 text-gray-600" :style="'font-size: 13px'" :placeholder="$t('add a description of the dataset goal...')"></textarea>
					</div>
					<div class="px-5 pb-5 text-center">
						<button class="btn box bg-green-600 text-white hover:bg-green-800 px-12 py-2 font-normal  text-center" @click="editDataset()">{{$t('SAVE')}}</button>
					</div>
                </div>

            </div>

            <div v-else class="intro-y col-span-12 lg:col-span-12 flex flex-col justify-center items-center mt-12 p-10 pt-5">
                <div class="flex items-center justify-center mt-5">
                    <img :src="require(`@/assets/images/rosepetal/icon/logoLoadingGray.png`)" class="w-20" />
                </div>
                <LoadingIcon icon="three-dots" class="w-10 h-10" />
            </div>

        </div>

    </div>
</template>

<script setup>
import { onMounted, ref }   from "vue";
import { helper as $h } 	from "@/utils/helper";
import * as rosepetalModel  from "rosepetal-model";


let $dataset = rosepetalModel.default.dataset;

const emit = defineEmits(['datasetEdited']);

const props = defineProps({
    dataset: {
        type: Object,
        required: true,
    }
});

const layout = ref({
    loading:        false,
    dataset:        { name: '', type: '' },
    newName:        '',
    newDescription: ''
});

const editDataset = async () => {
    if (layout.value.dataset) {
        layout.value.loading = true;
        await $dataset.update(layout.value.dataset.id, { name: layout.value.newName, description: layout.value.newDescription }).then( async () => { 
            $h.NotificationTxt({ text: "Dataset profile updated"});
            layout.value.dataset.name        = layout.value.newName;
            layout.value.dataset.description = layout.value.newDescription;
            emit('datasetEdited');
        })
    }
}

onMounted(() => {
    if (props.dataset) {
        layout.value.dataset        = props.dataset;
        layout.value.newName        = props.dataset.name;
        layout.value.newDescription = props.dataset.description;
    }
});
</script>